// Feature Configurations
import { useCurrentUser } from '@centecomm/portal-service-react';
import { User } from '@centecomm/portal-service';
import { FeatureApplication } from '../Types/FeatureApplication';
import { FeatureConfiguration } from '../Types/FeatureConfiguration';
import filterApplicationFeatures from './filterApplicationFeatures';

function useFeatureApplications(featureConfigurations: FeatureConfiguration[]): {
    featureApplications: FeatureApplication[];
} {
    const { hasPermission, currentUser } = useCurrentUser();

    const featureApplications: FeatureApplication[] = filterApplicationFeatures(
        featureConfigurations,
        hasPermission,
        currentUser as User,
    );

    return { featureApplications };
}

export default useFeatureApplications;
